import style from "../productEditForm.module.scss";
import React from "react";
import { Textarea } from "../../../../components/Textarea";
import { Label104x46 } from "../../../../components/Label";
import { useTranslation } from "react-i18next";

interface Props {
  specialDescription: string[];
  setSpecialDescription: (_: string[]) => void;
}

export function ProductEditSpecialDescription({ specialDescription, setSpecialDescription }: Props) {
  const { t } = useTranslation("product");
  return (
    <div className={style.field}>
      <Label104x46 text={t("edit.specialDescription.title")} className={style.label} />
      <Textarea
        style={{
          width: "100%",
          height: "100px",
        }}
        value={specialDescription.join("\n")}
        onChange={(e) => setSpecialDescription(e.target.value.split("\n"))}
        onBlur={() => setSpecialDescription(specialDescription.filter((line) => line !== ""))}
        placeholder={t("edit.specialDescription.placeholder")}
      />
    </div>
  );
}
